import { PathBase } from "@constellation-academy/epic-ui";

export class FilesPath extends PathBase {
	static readonly pathKey = "files";
}
